import React from 'react';
import { useCart } from '../context/CartContext';
import './Products.css';

function Fashion() {
  const { addToCart } = useCart();

  const fashionProducts = [
    {
      id: 'fash1',
      name: 'Premium Cotton T-Shirt',
      price: 29,
      originalPrice: 45,
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'Comfortable cotton t-shirt in various colors'
    },
    {
      id: 'fash2',
      name: 'Designer Jeans',
      price: 89,
      originalPrice: 120,
      image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'High-quality denim jeans with perfect fit'
    },
    {
      id: 'fash3',
      name: 'Leather Jacket',
      price: 199,
      originalPrice: 299,
      image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'Classic leather jacket for all seasons'
    },
    {
      id: 'fash4',
      name: 'Running Shoes',
      price: 79,
      originalPrice: 99,
      image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'Comfortable running shoes with cushioning'
    },
    {
      id: 'fash5',
      name: 'Designer Handbag',
      price: 149,
      originalPrice: 199,
      image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'Elegant leather handbag with multiple compartments'
    },
    {
      id: 'fash6',
      name: 'Sunglasses',
      price: 59,
      originalPrice: 89,
      image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'Stylish sunglasses with UV protection'
    },
    {
      id: 'fash7',
      name: 'Wristwatch',
      price: 129,
      originalPrice: 179,
      image: 'https://images.unsplash.com/photo-1524592094714-0f0654e20314?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'Elegant wristwatch with leather strap'
    },
    {
      id: 'fash8',
      name: 'Winter Scarf',
      price: 25,
      originalPrice: 35,
      image: 'https://images.unsplash.com/photo-1520903920245-00d872a2d1c9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Fashion',
      description: 'Warm wool scarf for cold weather'
    }
  ];

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="products-page">
      <div className="container">
        <div className="page-header">
          <h1>Fashion</h1>
          <p>Trendy clothing & accessories for every style</p>
        </div>
        
        <div className="product-grid">
          {fashionProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <p className="product-description">{product.description}</p>
                <div className="price">
                  <span className="current-price">${product.price}</span>
                  <span className="original-price">${product.originalPrice}</span>
                  <span className="discount">
                    {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% off
                  </span>
                </div>
                <button 
                  className="add-to-cart"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Fashion; 